import { useContext } from 'react';
import { secondaryDimensionLengthContext } from './context';
export var useSecondaryDimensionLength = function () {
    var listLength = useContext(secondaryDimensionLengthContext);
    return listLength;
};
